import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
// static
import EditIconOrigin from '@mui/icons-material/Edit'
import BackIconOrigin from '@mui/icons-material/KeyboardBackspace'
// utils
import { size } from 'polished'
// themes
import { colors } from 'themes'

const Wrapper = styled.div`
  height: 100%;
  padding: 16px 0 0 16px;

  & > div:first-child {
    padding-bottom: 8px;
  }
`

const TitleWrapper = styled('div')`
  font-size: 22px;
  margin-bottom: 12px;

  & > span:first-child {
    font-weight: bold;
  }

  & > span:last-child {
    display: block;
    font-size: 14px;
  }
`

const ContentWrapper = styled((props) => <Grid {...props} />)`
  padding-right: 16px;
  font-size: 16px;
`

const EditIcon = styled(EditIconOrigin)`
  margin-right: 5px;
  ${size('22px')};

  path {
    fill: ${colors.blue500};
  }
`

const EditIconWrapper = styled((props) => <Grid {...props} />)`
  cursor: pointer;
  color: ${colors.blue500};
  padding-right: 16px;
`

const BackIcon = styled(BackIconOrigin)`
  margin-right: 5px;
  ${size('26px')};
`

const BackIconWrapper = styled('div')`
  cursor: pointer;
  color: ${colors.blue500};
  flex-basis: 37%;
  gap: 4px;
  align-items: center;
  display: flex;
  white-space: nowrap;
`

const Scrollbar = styled(ScrollbarOrigin)`
  height: calc(100vh - 110px);
`

export { Wrapper, TitleWrapper, ContentWrapper, Scrollbar, EditIconWrapper, EditIcon, BackIconWrapper, BackIcon }
